import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Button, Icon } from "rhombus-react";

import { UPLOAD_CREATIVE_ID } from "utils/constants";
import { hasPermission } from "utils/common";
import { hasSocialConnections } from "selectors/Social";


import "./AddCreativeButton.css";

const UPLOAD_ACTION = {
	name: "Upload Creative",
	icon: "fas fa-upload",
	renderChild(){
		return (
			<div className="add-creative-link-container action-item" onClick={evt => document.getElementById(UPLOAD_CREATIVE_ID).click()}>
				<label htmlFor={UPLOAD_CREATIVE_ID} className="basic-item">
					<Icon  name="fas fa-upload" />
					<span className="title upload-creative">Upload Creative</span>
				</label>
			</div>
		);
	},
};
function createVast(routeLocation){
	return {
		name: "Create VAST",
		icon:  "fas fa-video",
		renderChild(){
			return (
				<div className="add-creative-link-container">
					<Link to={`${routeLocation}modal/create-vast/`} className="action-item">
						<Icon className="concept-icon" name="fas fa-video" />
						<span className="title create-vast">Create VAST Videos</span>
					</Link>
				</div>
			);
		},
	};
}
function createAudio(routeLocation){
	const name = "Create Audio";
	const icon = "fas fa-volume"; // TODO: Update to assetAudio after RRACT-168 is merged

	return {
		name,
		icon,
		renderChild(){
			return (
				<div className="add-creative-link-container">
					<Link to={`${routeLocation}modal/create-audio/`} className="action-item">
						<Icon className="concept-icon" name={icon} />
						<span className="title create-audio">{name}</span>
					</Link>
				</div>
			);
		},
	};
}
function createNative(routeLocation){
	return {
		name: "Create Native Ad",
		icon: "fas fa-ballot",
		renderChild(){
			return (
				<div className="add-creative-link-container">
					<Link to={`${routeLocation}modal/create-native-ad/`}>
						<Icon className="concept-icon" name="fas fa-ballot" />
						<span className="title create-native-ad">Create Native Ad</span>
					</Link>
				</div>
			);
		},
	};
}
// function openConcept(routeLocation){
// 	return {
// 		name: "Open Web Display Concept",
// 		icon: "fas fa-images",
// 		renderChild(){
// 			return (
// 				<div className="add-creative-link-container">
// 					<Link to={`${routeLocation}modal/open-web-display/`}>
// 						<Icon className="concept-icon"name= "fas fa-images" />
// 						<span className="title open-web-display">Open Web Display Concept</span>
// 					</Link>
// 				</div>
// 			);
// 		},
// 	};
// }
function openDisplayConcept(routeLocation){
	return {
		name: "Open Display Concept",
		icon: "fas fa-images",
		renderChild(){
			return (
				<div className="add-creative-link-container">
					<Link to={`${routeLocation}modal/create-concept/open/`} className="action-item">
						<Icon className="concept-icon" name="fas fa-images" />
						<span className="title open-display-concept">Open Display Concept</span>
					</Link>
				</div>
			);
		},
	};
}
function socialConcept(routeLocation, hasSocial){
	return {
		name: "Social Concept",
		icon: "fas fa-photo-video",
		value:"social",
		renderChild(){
			return (
				<div className="add-creative-link-container">
					<Link to={`${routeLocation}modal/${hasSocial}`} className="action-item">
						<Icon className="concept-icon" name="fas fa-photo-video" />
						<span className="title social-concept">Social Concept</span>
					</Link>
				</div>
			);
		},
	};
}

const VIEW = "Creative View";

export let PRIVATE = {
	UPLOAD_ACTION,
	createVast,
	createNative,
	createAudio,
	// openConcept,
	socialConcept,
};

export default function AddCreativeDropdown(props) {
	const {
		user,
		hasSocial,
		routeLocation,
	} = useSelector((state) => {
		return {
			routeLocation: state.router.location.pathname,
			hasSocial: hasSocialConnections(state),
			user:state.you,
		};
	});

	let hasSocialPath = hasSocial ? "create-concept/social/" : "no-integration/"
		, splitActions = []
		;

	if(hasPermission(user, VIEW, "Upload Ad Files")){
		splitActions = [
			UPLOAD_ACTION,
			openDisplayConcept(routeLocation),
			createVast(routeLocation),
			socialConcept(routeLocation, hasSocialPath),
			createAudio(routeLocation),
			createNative(routeLocation),
		];
	}

	if(splitActions.length===0){
		return null;
	}
	return (
		<Button
			icon="fas fa-plus-circle"
			style="block"
			isDropDown
			addClass="true"
			splitActions={splitActions}
			splitValue="add-creative">
			Add Creative
		</Button>
	);
}

AddCreativeDropdown.displayName = "AddCreativeDropdown";
